import React from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { imgs } from '../../assets/imgs'
import { icons } from '../../assets/icons'

export const AlertDeviceLandscape = () => {
	if (isMobile || isTablet) {
		return (
			<div className="landscape:hidden z-[100] fixed w-full h-full bg-[#282828] ">
				<div className="pt-6 h-1/12 flex justify-center">
					<img src={imgs.oxxo_logo_white} className="w-[72px] sm:w-[132px] h-10 sm:h-[73px] object-contain" alt="" />
				</div>
				<div className='h-11/12 flex flex-col justify-center items-center '>
					<img src={icons.landscape_icons} className="w-[166px] sm:w-[255px] h-[186px] sm:h-[284px] " alt="" />
					<p className='text-white font-bold text-2xl sm:text-4xl pt-9'>Modo Vertical detectado</p>
					<p className='text-white text-sm sm:text-lg font-normal  text-center w-[291px] pt-4'>Esta experiencia es exclusiva para un modo horizontal. Por favor rota tu dispositivo de la forma óptima</p>
				</div>
			</div>
		)
	}
}
